import React from 'react'
import { AddressForm } from './AddressForm'

const Body = props => (
  <div className='row px-0 pb-2 space-m'>
    <div className='col-12 px-3 border-top border-color-ui-2'>
      <div className='row mx-0'>
        <AddressForm {...props} />
      </div>
    </div>
  </div>
)

export default Body



// WEBPACK FOOTER //
// ./src/features/Checkout/ShippingAddress/Body/Body.js